import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

// FAQ Data
const faqData = [
  {
    question: "What makes organic pads different from regular pads?",
    answer: "Organic pads are made from 100% natural, chemical-free cotton and biodegradable materials, unlike conventional pads which contain synthetic materials and chemicals. They're better for both your health and the environment."
  },
  {
    question: "Are organic pads as absorbent as regular pads?",
    answer: "Yes! Organic cotton actually has excellent absorbency properties. Our organic pads are designed to provide the same level of protection as conventional pads, with different absorbency levels available for various flow needs."
  },
  {
    question: "Do organic pads cost more than regular pads?",
    answer: "While organic pads may have a slightly higher upfront cost, they offer better value considering their health and environmental benefits. Many users find the additional cost worth it for the peace of mind and comfort they provide."
  },
  {
    question: "How long can I wear an organic pad?",
    answer: "Like regular pads, organic pads should be changed every 4-6 hours for optimal hygiene and comfort, or more frequently during heavy flow days. Never exceed 8 hours of continuous use."
  },
  {
    question: "Are organic pads safe for sensitive skin?",
    answer: "Yes! Organic pads are especially good for sensitive skin as they're free from harsh chemicals, dyes, and synthetic materials that can cause irritation. They're hypoallergenic and perfect for those with sensitive skin or allergies."
  },
  {
    question: "How do I know if a pad is truly organic?",
    answer: "Look for certifications like GOTS (Global Organic Textile Standard) or OCS (Organic Content Standard). These certifications ensure the materials are genuinely organic and processed according to environmental and social criteria."
  },
  {
    question: "Are organic pads biodegradable?",
    answer: "Yes, organic pads are biodegradable as they're made from natural materials. However, they should still be disposed of properly in waste bins, not flushed down toilets. They will decompose much faster than conventional pads in landfills."
  },
  {
    question: "Can organic pads cause infections?",
    answer: "No, properly used organic pads are actually less likely to cause infections compared to synthetic pads. The natural, breathable cotton helps prevent bacterial growth. However, like any menstrual product, they should be changed regularly."
  },
  {
    question: "Do organic pads have wings?",
    answer: "Yes, many organic pad brands offer options with wings for extra protection. The wings are also made from organic materials and provide the same secure fit as conventional pads."
  },
  {
    question: "How should I store organic pads?",
    answer: "Store organic pads in a cool, dry place away from direct sunlight. Keep them in their original packaging or a breathable container to maintain hygiene. Avoid storing in bathroom cabinets where humidity can be high."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <h2 className="text-3xl font-bold text-center mb-8 text-[#679729]">Frequently Asked Questions</h2>
      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <div 
            key={index}
            className="border border-[#679729]/20 rounded-lg overflow-hidden bg-white shadow-sm"
          >
            <button
              className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-[#679729]/10 transition-colors"
              onClick={() => toggleQuestion(index)}
            >
              <span className="font-medium text-[#679729]">{faq.question}</span>
              <ChevronDown 
                className={`transform transition-transform ${
                  openIndex === index ? 'rotate-180' : ''
                } text-[#679729]`}
                size={20}
              />
            </button>
            <div
              className={`px-6 transition-all duration-200 ease-in-out ${
                openIndex === index ? 'py-4 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
              }`}
            >
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;